<template>
  <div class="animated fadeInUp" id="dashboard">
    <div class="section">
      <h3 class="text-bold text-center text-md-left text-primary mt-3">
        <svg
          width="59"
          height="44"
          viewBox="0 0 50 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="d-inline-block d-md-none"
        >
          <path
            d="M37.2686 12.9122C40.3855 12.9122 42.9122 11.4768 42.9122 9.70612C42.9122 7.93543 40.3855 6.5 37.2686 6.5C34.1517 6.5 31.625 7.93543 31.625 9.70612C31.625 11.4768 34.1517 12.9122 37.2686 12.9122Z"
            fill="#0070BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M37.3531 14.7566C33.3166 14.7566 31.7095 13.065 31.7095 12.0851V16.2825C31.7095 18.0538 34.2364 19.487 37.3531 19.487C40.4731 19.487 43 18.0538 43 16.2825V12.1859C43 13.1674 41.3913 14.7566 37.3531 14.7566Z"
            fill="#0070BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M37.3531 21.242C33.7424 21.242 31.7095 19.6154 31.7095 18.6355V22.7939C31.7095 24.5651 34.2364 26 37.3531 26C40.4731 26 43 24.5651 43 22.7939V18.5851C43 19.565 40.9655 21.242 37.3531 21.242Z"
            fill="#0070BA"
          />
          <path
            d="M23.3976 6.41225C26.9309 6.41225 29.7952 4.97682 29.7952 3.20612C29.7952 1.43543 26.9309 0 23.3976 0C19.8643 0 17 1.43543 17 3.20612C17 4.97682 19.8643 6.41225 23.3976 6.41225Z"
            fill="#0070BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.6007 8.25664C19.0264 8.25664 17.2031 6.56502 17.2031 5.58514V9.78252C17.2031 11.5538 20.068 12.987 23.6007 12.987C27.1367 12.987 30 11.5538 30 9.78252V5.68589C30 6.66739 28.1751 8.25664 23.6007 8.25664Z"
            fill="#0070BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.6007 14.742C19.5074 14.742 17.2031 13.1154 17.2031 12.1355V16.2939C17.2031 18.0651 20.068 19.5 23.6007 19.5C27.1367 19.5 30 18.0651 30 16.2939V12.0851C30 13.065 27.6925 14.742 23.6007 14.742Z"
            fill="#0070BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.6007 21.242C19.5074 21.242 17.2031 19.6154 17.2031 18.6355V22.7939C17.2031 24.5651 20.068 26 23.6007 26C27.1367 26 30 24.5651 30 22.7939V18.5851C30 19.565 27.6925 21.242 23.6007 21.242Z"
            fill="#0070BA"
          />
        </svg>
        Settlements
      </h3>
      <h4
        class="
          text-primary text-md-dark text-center text-md-left
          d-none d-md-block
        "
      >
        A History Of Your Settlements
      </h4>
      <div class="has-text-centered">
        <div class="has-text-centered">
          <div class="pt-20">
            <div class="">
              <div class="hr-content">
                <div class="bg-white pb-50 the-table">
                  <b-table
                    class="d-none d-md-inline-table"
                    ref="table"
                    id="my-table"
                    hover
                    head-variant="dark"
                    :items="settlements"
                    :fields="masterTableProps.fields"
                    :per-page="masterTableProps.resultsPerPage"
                    :current-page="masterTableProps.currentPage"
                    :sort-by.sync="masterTableProps.sortBy"
                    :sort-direction="masterTableProps.sortDirection"
                    :sort-desc.sync="masterTableProps.sortDesc"
                    show-empty
                    :busy="settlementsIsReady"
                  >
                    <template #empty>
                      <empty-table></empty-table>
                    </template>
                    <template #table-busy>
                      <div class="d-flex justify-content-center">
                        <spinner></spinner>
                      </div>
                    </template>
                    <template #cell(created_at)="data">
                      {{
                        new Date(data.item.created_at)
                          | dateFormat('DD/MM/YYYY h:mm A')
                      }}
                    </template>
                    <template #cell(settlement_amount)="data">
                      GHS {{ data.item.settlement_amount | currency }}
                    </template>
                    <template #cell(paid_out_to)="">Bank</template>
                    <template #cell(status)="">
                      <status-button :status="'paid'" />
                    </template>
                    <template #cell(details)="data">
                      <b-button
                        pill
                        variant="primary"
                        class="table-btn"
                        @click="showDetail(data.item)"
                        >View</b-button
                      >
                    </template>
                  </b-table>

                  <div class="d-flex d-md-none pb-5">
                    <input
                      type="text"
                      class="form-control rounded-pill"
                      placeholder="Search Settlements"
                      v-model="search"
                    />
                    <filters-mobile
                      :hidePayers="true"
                      @filtersSubmit="filtersSubmit"
                      @reset="clear"
                    />
                  </div>

                  <!-- todo: deprecate filter_mobile -->
                  <mobile-transaction
                    :transactions="settlements"
                    :loading="settlementsIsReady"
                    :limit="10"
                    :type="table_type"
                    :hasRoute="true"
                    :routerLink="router_link"
                    :filter="filter_mobile"
                    :search="search"
                  />

                  <table-pagination
                    :totalRows="rows"
                    @paginationChange="handlePaginationChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterSpacing></FooterSpacing>
    </div>
  </div>
</template>
<script>
import TransactionAPI from '../api/transactions_api';
import store from '../store';
import { tableMixin } from '../utils/table.mixin';
import spinner from '../utils/Spinner';
import EmptyTable from '../utils/empty-table.vue';
import MobileTransaction from '../components/MobileTransaction.vue';
import FooterSpacing from '../components/FooterMobile.vue';
import filtersMobile from '../components/filtersMobile.vue';
import StatusButton from '../components/StatusButton.vue';
import TablePagination from '../components/TablePagination.vue';

export default {
  mixins: [tableMixin],
  components: {
    spinner,
    EmptyTable,
    MobileTransaction,
    FooterSpacing,
    filtersMobile,
    StatusButton,
    TablePagination,
  },
  data() {
    return {
      search: '',
      settlements_name: [],
      router_link: '/vendor-settlements/',
      table_type: 'settlements',
      authenticated: '',
      loggedInUser: {},
      filterTerm: '',
      masterTableProps: {
        fields: [
          {
            key: 'created_at',
            sortable: true,
            label: 'Date',
          },
          {
            key: 'short_id',
            sortable: false,
            label: 'JetpayID',
          },
          {
            key: 'settlement_amount',
            sortable: false,
            label: 'Amount',
          },
          {
            key: 'paid_out_to',
            sortable: true,
            label: 'Paid To',
          },
          {
            key: 'status',
            sortable: false,
            label: 'Status',
          },
          {
            key: 'details',
            sortable: false,
            label: 'Details',
          },
        ],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDirection: 'asc',
        totalRows: 1,
        sortDesc: true,
      },
      filter_mobile: {},
    };
  },
  props: ['session'],
  mounted() {
    this.getSettlements();
  },
  methods: {
    filtersSubmit(params) {
      this.getSettlements(params);
    },
    clear: function () {
      store.dispatch('resetFilterProperties');
      this.getSettlements();
    },
    getSettlements(params) {
      TransactionAPI.methods.getSettlements(params);
    },
    showDetail(event) {
      console.log('showDetail', event);

      this.currentSettlement = store.getters.getSettlementById(event.id);
      const id = event.id;
      this.$router.push('/vendor-settlements/' + id);
    },
    handlePaginationChange(page_number) {
      this.getSettlements({
        ...this.filterProperties,
        page: page_number,
      });
    },
  },
  computed: {
    filterProperties: {
      get: function () {
        return store.state.filterProperties;
      },
      set: function (newValue) {
        store.state.filterProperties = newValue;
      },
    },
    settlementsIsReady() {
      if (this.axiosRequestAmount == 0) {
        return false;
      }

      return true;
    },
    axiosRequestAmount: {
      get: function () {
        return store.state.axiosRequestAmount;
      },
      set: function (newValue) {
        store.state.axiosRequestAmount = newValue;
      },
    },
    rows() {
      return store.state.settlements.count;
    },
    settlements: {
      get: function () {
        return store.state.settlements.results;
      },
      set: function (newValue) {
        store.state.settlements.results = newValue;
      },
    },
    currentSettlement: {
      get: function () {
        return store.state.currentSettlement;
      },
      set: function (newValue) {
        store.state.currentSettlement = newValue;
      },
    },
    // settlementsTransactionNames: {
    //   get: function () {
    //     return store.state.settlementsTransactionNames;
    //   },
    //   set: function (newValue) {
    //     store.state.settlementsTransactionNames = newValue;
    //   }
    // }
  },
};
</script>
<style scoped>
@import '../assets/css/table.css';

body {
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
  color: #444f60;
}
.table-btn {
  padding: 4px 30px;
}
.pagination ul li {
  display: inline-block;
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
}
</style>
